import { h as ra, j as Q, c as ta, a as W, b as j, e as sa, i as na, _ as ia } from "./_getTag.B1GM_Sq5.js";
import { b as _a, a as la, i as fa } from "./isObjectLike.YJTOHc8M.js";
import { i as I } from "./isArray.CAJdVVdL.js";
function ha() {
  this.__data__ = [], this.size = 0;
}
var ua = ha;
function va(a, e) {
  return a === e || a !== a && e !== e;
}
var V = va, pa = V;
function ca(a, e) {
  for (var r = a.length; r--; )
    if (pa(a[r][0], e))
      return r;
  return -1;
}
var m = ca, oa = m, da = Array.prototype, ga = da.splice;
function ya(a) {
  var e = this.__data__, r = oa(e, a);
  if (r < 0)
    return !1;
  var t = e.length - 1;
  return r == t ? e.pop() : ga.call(e, r, 1), --this.size, !0;
}
var $a = ya, Aa = m;
function Ca(a) {
  var e = this.__data__, r = Aa(e, a);
  return r < 0 ? void 0 : e[r][1];
}
var Oa = Ca, ba = m;
function Sa(a) {
  return ba(this.__data__, a) > -1;
}
var wa = Sa, Ta = m;
function ma(a, e) {
  var r = this.__data__, t = Ta(r, a);
  return t < 0 ? (++this.size, r.push([a, e])) : r[t][1] = e, this;
}
var Pa = ma, Da = ua, Ea = $a, La = Oa, xa = wa, Ia = Pa;
function $(a) {
  var e = -1, r = a == null ? 0 : a.length;
  for (this.clear(); ++e < r; ) {
    var t = a[e];
    this.set(t[0], t[1]);
  }
}
$.prototype.clear = Da;
$.prototype.delete = Ea;
$.prototype.get = La;
$.prototype.has = xa;
$.prototype.set = Ia;
var P = $, Ha = P;
function Ga() {
  this.__data__ = new Ha(), this.size = 0;
}
var Ma = Ga;
function Ra(a) {
  var e = this.__data__, r = e.delete(a);
  return this.size = e.size, r;
}
var za = Ra;
function qa(a) {
  return this.__data__.get(a);
}
var Ka = qa;
function Na(a) {
  return this.__data__.has(a);
}
var Ba = Na, Ua = ra, Fa = Ua(Object, "create"), D = Fa, G = D;
function Xa() {
  this.__data__ = G ? G(null) : {}, this.size = 0;
}
var Ya = Xa;
function Za(a) {
  var e = this.has(a) && delete this.__data__[a];
  return this.size -= e ? 1 : 0, e;
}
var Ja = Za, Qa = D, Wa = "__lodash_hash_undefined__", ja = Object.prototype, Va = ja.hasOwnProperty;
function ka(a) {
  var e = this.__data__;
  if (Qa) {
    var r = e[a];
    return r === Wa ? void 0 : r;
  }
  return Va.call(e, a) ? e[a] : void 0;
}
var ae = ka, ee = D, re = Object.prototype, te = re.hasOwnProperty;
function se(a) {
  var e = this.__data__;
  return ee ? e[a] !== void 0 : te.call(e, a);
}
var ne = se, ie = D, _e = "__lodash_hash_undefined__";
function le(a, e) {
  var r = this.__data__;
  return this.size += this.has(a) ? 0 : 1, r[a] = ie && e === void 0 ? _e : e, this;
}
var fe = le, he = Ya, ue = Ja, ve = ae, pe = ne, ce = fe;
function A(a) {
  var e = -1, r = a == null ? 0 : a.length;
  for (this.clear(); ++e < r; ) {
    var t = a[e];
    this.set(t[0], t[1]);
  }
}
A.prototype.clear = he;
A.prototype.delete = ue;
A.prototype.get = ve;
A.prototype.has = pe;
A.prototype.set = ce;
var oe = A, M = oe, de = P, ge = Q;
function ye() {
  this.size = 0, this.__data__ = {
    hash: new M(),
    map: new (ge || de)(),
    string: new M()
  };
}
var $e = ye;
function Ae(a) {
  var e = typeof a;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? a !== "__proto__" : a === null;
}
var Ce = Ae, Oe = Ce;
function be(a, e) {
  var r = a.__data__;
  return Oe(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
var E = be, Se = E;
function we(a) {
  var e = Se(this, a).delete(a);
  return this.size -= e ? 1 : 0, e;
}
var Te = we, me = E;
function Pe(a) {
  return me(this, a).get(a);
}
var De = Pe, Ee = E;
function Le(a) {
  return Ee(this, a).has(a);
}
var xe = Le, Ie = E;
function He(a, e) {
  var r = Ie(this, a), t = r.size;
  return r.set(a, e), this.size += r.size == t ? 0 : 1, this;
}
var Ge = He, Me = $e, Re = Te, ze = De, qe = xe, Ke = Ge;
function C(a) {
  var e = -1, r = a == null ? 0 : a.length;
  for (this.clear(); ++e < r; ) {
    var t = a[e];
    this.set(t[0], t[1]);
  }
}
C.prototype.clear = Me;
C.prototype.delete = Re;
C.prototype.get = ze;
C.prototype.has = qe;
C.prototype.set = Ke;
var k = C, Ne = P, Be = Q, Ue = k, Fe = 200;
function Xe(a, e) {
  var r = this.__data__;
  if (r instanceof Ne) {
    var t = r.__data__;
    if (!Be || t.length < Fe - 1)
      return t.push([a, e]), this.size = ++r.size, this;
    r = this.__data__ = new Ue(t);
  }
  return r.set(a, e), this.size = r.size, this;
}
var Ye = Xe, Ze = P, Je = Ma, Qe = za, We = Ka, je = Ba, Ve = Ye;
function O(a) {
  var e = this.__data__ = new Ze(a);
  this.size = e.size;
}
O.prototype.clear = Je;
O.prototype.delete = Qe;
O.prototype.get = We;
O.prototype.has = je;
O.prototype.set = Ve;
var ke = O, ar = "__lodash_hash_undefined__";
function er(a) {
  return this.__data__.set(a, ar), this;
}
var rr = er;
function tr(a) {
  return this.__data__.has(a);
}
var sr = tr, nr = k, ir = rr, _r = sr;
function T(a) {
  var e = -1, r = a == null ? 0 : a.length;
  for (this.__data__ = new nr(); ++e < r; )
    this.add(a[e]);
}
T.prototype.add = T.prototype.push = ir;
T.prototype.has = _r;
var lr = T;
function fr(a, e) {
  for (var r = -1, t = a == null ? 0 : a.length; ++r < t; )
    if (e(a[r], r, a))
      return !0;
  return !1;
}
var hr = fr;
function ur(a, e) {
  return a.has(e);
}
var vr = ur, pr = lr, cr = hr, or = vr, dr = 1, gr = 2;
function yr(a, e, r, t, n, s) {
  var _ = r & dr, l = a.length, f = e.length;
  if (l != f && !(_ && f > l))
    return !1;
  var i = s.get(a), c = s.get(e);
  if (i && c)
    return i == e && c == a;
  var u = -1, h = !0, o = r & gr ? new pr() : void 0;
  for (s.set(a, e), s.set(e, a); ++u < l; ) {
    var v = a[u], p = e[u];
    if (t)
      var d = _ ? t(p, v, u, e, a, s) : t(v, p, u, a, e, s);
    if (d !== void 0) {
      if (d)
        continue;
      h = !1;
      break;
    }
    if (o) {
      if (!cr(e, function(g, y) {
        if (!or(o, y) && (v === g || n(v, g, r, t, s)))
          return o.push(y);
      })) {
        h = !1;
        break;
      }
    } else if (!(v === p || n(v, p, r, t, s))) {
      h = !1;
      break;
    }
  }
  return s.delete(a), s.delete(e), h;
}
var aa = yr, $r = _a, Ar = $r.Uint8Array, Cr = Ar;
function Or(a) {
  var e = -1, r = Array(a.size);
  return a.forEach(function(t, n) {
    r[++e] = [n, t];
  }), r;
}
var br = Or;
function Sr(a) {
  var e = -1, r = Array(a.size);
  return a.forEach(function(t) {
    r[++e] = t;
  }), r;
}
var wr = Sr, R = la, z = Cr, Tr = V, mr = aa, Pr = br, Dr = wr, Er = 1, Lr = 2, xr = "[object Boolean]", Ir = "[object Date]", Hr = "[object Error]", Gr = "[object Map]", Mr = "[object Number]", Rr = "[object RegExp]", zr = "[object Set]", qr = "[object String]", Kr = "[object Symbol]", Nr = "[object ArrayBuffer]", Br = "[object DataView]", q = R ? R.prototype : void 0, L = q ? q.valueOf : void 0;
function Ur(a, e, r, t, n, s, _) {
  switch (r) {
    case Br:
      if (a.byteLength != e.byteLength || a.byteOffset != e.byteOffset)
        return !1;
      a = a.buffer, e = e.buffer;
    case Nr:
      return !(a.byteLength != e.byteLength || !s(new z(a), new z(e)));
    case xr:
    case Ir:
    case Mr:
      return Tr(+a, +e);
    case Hr:
      return a.name == e.name && a.message == e.message;
    case Rr:
    case qr:
      return a == e + "";
    case Gr:
      var l = Pr;
    case zr:
      var f = t & Er;
      if (l || (l = Dr), a.size != e.size && !f)
        return !1;
      var i = _.get(a);
      if (i)
        return i == e;
      t |= Lr, _.set(a, e);
      var c = mr(l(a), l(e), t, n, s, _);
      return _.delete(a), c;
    case Kr:
      if (L)
        return L.call(a) == L.call(e);
  }
  return !1;
}
var Fr = Ur;
function Xr(a, e) {
  for (var r = -1, t = e.length, n = a.length; ++r < t; )
    a[n + r] = e[r];
  return a;
}
var Yr = Xr, Zr = Yr, Jr = I;
function Qr(a, e, r) {
  var t = e(a);
  return Jr(a) ? t : Zr(t, r(a));
}
var Wr = Qr;
function jr(a, e) {
  for (var r = -1, t = a == null ? 0 : a.length, n = 0, s = []; ++r < t; ) {
    var _ = a[r];
    e(_, r, a) && (s[n++] = _);
  }
  return s;
}
var Vr = jr;
function kr() {
  return [];
}
var at = kr, et = Vr, rt = at, tt = Object.prototype, st = tt.propertyIsEnumerable, K = Object.getOwnPropertySymbols, nt = K ? function(a) {
  return a == null ? [] : (a = Object(a), et(K(a), function(e) {
    return st.call(a, e);
  }));
} : rt, it = nt;
function _t(a, e) {
  for (var r = -1, t = Array(a); ++r < a; )
    t[r] = e(r);
  return t;
}
var lt = _t, ft = 9007199254740991, ht = /^(?:0|[1-9]\d*)$/;
function ut(a, e) {
  var r = typeof a;
  return e = e ?? ft, !!e && (r == "number" || r != "symbol" && ht.test(a)) && a > -1 && a % 1 == 0 && a < e;
}
var vt = ut, pt = lt, ct = ta, ot = I, dt = W, gt = vt, yt = j, $_t = Object.prototype, At = $_t.hasOwnProperty;
function Ct(a, e) {
  var r = ot(a), t = !r && ct(a), n = !r && !t && dt(a), s = !r && !t && !n && yt(a), _ = r || t || n || s, l = _ ? pt(a.length, String) : [], f = l.length;
  for (var i in a)
    (e || At.call(a, i)) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
    (i == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (i == "offset" || i == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (i == "buffer" || i == "byteLength" || i == "byteOffset") || // Skip index properties.
    gt(i, f))) && l.push(i);
  return l;
}
var Ot = Ct, bt = Ot, St = sa, wt = na;
function Tt(a) {
  return wt(a) ? bt(a) : St(a);
}
var mt = Tt, Pt = Wr, Dt = it, Et = mt;
function Lt(a) {
  return Pt(a, Et, Dt);
}
var xt = Lt, N = xt, It = 1, Ht = Object.prototype, Gt = Ht.hasOwnProperty;
function Mt(a, e, r, t, n, s) {
  var _ = r & It, l = N(a), f = l.length, i = N(e), c = i.length;
  if (f != c && !_)
    return !1;
  for (var u = f; u--; ) {
    var h = l[u];
    if (!(_ ? h in e : Gt.call(e, h)))
      return !1;
  }
  var o = s.get(a), v = s.get(e);
  if (o && v)
    return o == e && v == a;
  var p = !0;
  s.set(a, e), s.set(e, a);
  for (var d = _; ++u < f; ) {
    h = l[u];
    var g = a[h], y = e[h];
    if (t)
      var H = _ ? t(y, g, h, e, a, s) : t(g, y, h, a, e, s);
    if (!(H === void 0 ? g === y || n(g, y, r, t, s) : H)) {
      p = !1;
      break;
    }
    d || (d = h == "constructor");
  }
  if (p && !d) {
    var b = a.constructor, S = e.constructor;
    b != S && "constructor" in a && "constructor" in e && !(typeof b == "function" && b instanceof b && typeof S == "function" && S instanceof S) && (p = !1);
  }
  return s.delete(a), s.delete(e), p;
}
var Rt = Mt, x = ke, zt = aa, qt = Fr, Kt = Rt, B = ia, U = I, F = W, Nt = j, Bt = 1, X = "[object Arguments]", Y = "[object Array]", w = "[object Object]", Ut = Object.prototype, Z = Ut.hasOwnProperty;
function Ft(a, e, r, t, n, s) {
  var _ = U(a), l = U(e), f = _ ? Y : B(a), i = l ? Y : B(e);
  f = f == X ? w : f, i = i == X ? w : i;
  var c = f == w, u = i == w, h = f == i;
  if (h && F(a)) {
    if (!F(e))
      return !1;
    _ = !0, c = !1;
  }
  if (h && !c)
    return s || (s = new x()), _ || Nt(a) ? zt(a, e, r, t, n, s) : qt(a, e, f, r, t, n, s);
  if (!(r & Bt)) {
    var o = c && Z.call(a, "__wrapped__"), v = u && Z.call(e, "__wrapped__");
    if (o || v) {
      var p = o ? a.value() : a, d = v ? e.value() : e;
      return s || (s = new x()), n(p, d, r, t, s);
    }
  }
  return h ? (s || (s = new x()), Kt(a, e, r, t, n, s)) : !1;
}
var Xt = Ft, Yt = Xt, J = fa;
function ea(a, e, r, t, n) {
  return a === e ? !0 : a == null || e == null || !J(a) && !J(e) ? a !== a && e !== e : Yt(a, e, r, t, ea, n);
}
var Wt = ea;
export {
  Wt as _,
  ke as a,
  k as b,
  vt as c,
  mt as k
};
//# sourceMappingURL=_baseIsEqual.CLFNswVP.js.map
